/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeDefinitionForDateTime extends models.AttributeDefinitionBase {
    constructor() {
        super();
        this.setDiscriminator("AttributeDefinitionForDateTime");
    }

    getFixupPrototypeFunction() { return AttributeDefinitionForDateTime.fixupPrototype; }

    static newInstance(model: Partial<AttributeDefinitionForDateTime>): AttributeDefinitionForDateTime {
        let obj = Object.assign(new AttributeDefinitionForDateTime(), model);
        AttributeDefinitionForDateTime.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeDefinitionForDateTime>): AttributeDefinitionForDateTime {
        if (!model) return null;
        return AttributeDefinitionForDateTime.newInstance(<AttributeDefinitionForDateTime> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeDefinitionForDateTime) {
        if (!obj) return;

        models.AttributeDefinitionForDateTime.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeDefinitionForDateTime): boolean {
        if (models.AttributeDefinitionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AttributeDefinitionForDateTime.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.min_date === "string") {
            this.min_date = new Date(<string><any>this.min_date);
        }
        if (typeof this.max_date === "string") {
            this.max_date = new Date(<string><any>this.max_date);
        }
    }

    /**
     * Minimum Allowed Date
     */
    min_date: Date;

    /**
     * Maximum Allowed Date
     */
    max_date: Date;

}
